import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';

import { MainLayout, useLayoutContext } from '@views/layouts';
import Breadcrumb from '@views/modules/cart/components/breadcrumb';
import Cart from '@views/modules/cart';
import Recommend from '@views/modules/home/sub-modules/product-list/dynamic';
import InterestList from '@views/modules/interest-product/components/product-list/lazy';

const Content = React.memo(() => {
  const [timestamp, setTimestamp] = React.useState<number>(null);
  const { me } = useLayoutContext();
  const isAuthorized = me && !me.isEmpty();
  React.useEffect(() => {
    setTimestamp(Date.now());
    return () => {
      setTimestamp(0);
    };
  }, []);

  if (isAuthorized) {
    return <InterestList key={timestamp} customerId={me.get('id')} />;
  }

  return <Recommend />;
});

export const CartPage: NextPage = (): JSX.Element => {
  return (
    <MainLayout breadcrumb={<Breadcrumb />}>
      <NextSeo title="Giỏ hàng" nofollow noindex />
      <Cart />
      <Content />
    </MainLayout>
  );
};

export default CartPage;
